import Link from 'next/link'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { CheckCircle } from 'lucide-react'

interface PricingCardsProps {
  buildLoginRedirect: (target: string) => string
  isVisible: boolean
}

export default function PricingCards({ buildLoginRedirect, isVisible }: PricingCardsProps) {
  return (
    <section
      className={`w-full bg-gradient-to-b from-slate-50 to-white px-4 py-16 sm:px-6 md:py-20 lg:px-8 transition-all duration-700 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
    >
      <div className="mx-auto max-w-6xl">
        <div className="mb-12 text-center">
          <h2 className="mb-2 text-3xl font-bold text-gray-900 md:text-4xl">프리랜서는 무료입니다</h2>
          <p className="mx-auto max-w-2xl text-base text-gray-600 md:text-lg">
            가입부터 제안 제출까지, 프리랜서 핵심 기능은 항상 무료입니다
          </p>
        </div>

        <div className="flex justify-center">
          <Card className="flex h-full w-full max-w-2xl flex-col rounded-2xl border-2 border-[#06f] bg-white shadow-lg transition-all hover:shadow-xl hover:-translate-y-1">
            <CardHeader className="pb-3">
              <div className="flex items-center gap-3">
                <CardTitle className="text-2xl font-bold text-gray-900">무료 플랜</CardTitle>
                <span className="inline-flex items-center rounded-full bg-[#06f]/10 px-3 py-1 text-xs font-semibold text-[#06f]">
                  수수료 없이 시작
                </span>
              </div>
            </CardHeader>

            <CardContent className="flex h-full flex-1 flex-col space-y-5">
              {/* CTA 버튼 - 체크리스트 위로 이동 */}
              <Button asChild className="h-12 w-full whitespace-nowrap bg-[#06f] px-4 text-center text-sm font-semibold leading-none text-white hover:bg-[#005eeb] sm:text-base">
                <Link href={buildLoginRedirect('/onboarding/freelancer/role')} className="inline-flex w-full items-center justify-center whitespace-nowrap">
                  프로필 등록하고 시작하기
                </Link>
              </Button>

              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <CheckCircle className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#06f]" />
                  <div>
                    <span className="text-sm font-medium text-gray-900">프로젝트 탐색 및 검색</span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#06f]" />
                  <div>
                    <span className="text-sm font-medium text-gray-900">개인/팀 제안 제출</span>
                    <span className="ml-2 text-xs text-gray-500">· 팀 참여 가능</span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#06f]" />
                  <div>
                    <span className="text-sm font-medium text-gray-900">포트폴리오로 신뢰 확보</span>
                    <span className="ml-2 text-xs text-gray-500">· 프로필 관리</span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#06f]" />
                  <div>
                    <span className="text-sm font-medium text-gray-900">맞춤 프로젝트 알림 확인</span>
                    <span className="ml-2 text-xs text-gray-500">· 프리랜서 풀 등록 기반</span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#06f]" />
                  <div>
                    <span className="text-sm font-medium text-gray-900">팀으로도 손쉽게 제안</span>
                    <span className="ml-2 text-xs text-gray-500">· 팀 구성 및 관리</span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#06f]" />
                  <div>
                    <span className="text-sm font-medium text-gray-900">채팅으로 빠르게 협의</span>
                    <span className="ml-2 text-xs text-gray-500">· 메시지 및 협업</span>
                  </div>
                </li>
              </ul>

              {/* 무료 범위 명시 */}
              <div className="mt-4 border-t border-gray-200 pt-4">
                <p className="text-xs text-gray-500 text-center">
                  프리랜서 가입·프로필·제안 제출은 무료입니다. 결제는 기업 크레딧 모델로 운영됩니다.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>

      </div>
    </section>
  )
}
